export const previewSteps = [
  {
    title: "Welcome Call With Expert Advisor",
    description:
      "In the next 48 hours, you'll be contacted by your personal debt advisor for a comprehensive overview of your plan.",
  },
  {
    title: "Program Onboarding",
    description:
      "We'll guide you through the initial stages of your program, setting up any necessary arrangements and ensuring you're comfortable with the process.",
  },
  {
    title: "Educational Resources",
    description:
      "Access to our library of financial education resources. These tools are designed to empower you with knowledge and skills for managing your finances effectively.",
  },
];
